const BASE: string = (import.meta.env.VITE_API_URL as string | undefined) ?? "";

export async function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  // FormData bodies must NOT get an explicit Content-Type — the browser sets
  // multipart/form-data with the boundary parameter itself.
  const isFormData = init?.body instanceof FormData;

  return fetch(`${BASE}${path}`, {
    credentials: "include",
    ...init,
    headers: {
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...init?.headers,
    },
  });
}
